import React from 'react'
import { Input } from '@mui/material'
import { useForm } from 'react-hook-form'

const LoginPage = () => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm()
  const onSubmit = React.useCallback(values => {
    console.log(values)
    reset()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className="px-6">
      <form onSubmit={handleSubmit(onSubmit)}>
        <input defaultValue="test" {...register('example')} />
        <label>Tên đăng nhập h</label>
        <Input />

        <input {...register('exampleRequired', { required: true })} />
        {errors.exampleRequired && <span>This field is required</span>}

        <input type="submit" />
      </form>
    </div>
  )
}

export default LoginPage
